import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
export default function TabsHeader({ selected, setSelected, tab }) {
  return (
    <>
      <div className="ob-tab-header">
        <div className="ob-container">
          <ul className="ob-tab-header-wrap">
            <Swiper
              breakpoints={{
                320: {
                  slidesPerView: "auto",
                  spaceBetween: 0,
                },
                768: {
                  slidesPerView: "auto",
                  spaceBetween: 0,
                },
              }}
            >
              {tab.map((item) => (
                <SwiperSlide key={item.id}>
                  <button
                    onClick={() => setSelected(item)}
                    className={`ob-tab-header-item ${
                      item === selected ? "selected" : ""
                    }`}
                  >
                    <h2>{item.tabHeader.number}</h2>
                    <h5>{item.tabHeader.text}</h5>
                  </button>
                  {item === selected ? (
                    <motion.div className="ob-underline" layoutId="underline" />
                  ) : null}
                </SwiperSlide>
              ))}
            </Swiper>
          </ul>
        </div>
      </div>
    </>
  );
}
